import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="px-4 py-24 text-center max-w-md mx-auto" data-testid="payment-cancel-page">
      <XCircle className="h-16 w-16 mx-auto text-muted-foreground" />
      <h1 className="font-display font-bold text-2xl mt-4">Payment cancelled</h1>
      <p className="text-muted-foreground mt-2">
        No worries — your selections are safe. You can try again anytime.
      </p>
      <button
        onClick={() => navigate("/cart")}
        className="mt-6 px-6 h-11 bg-primary text-white rounded-full font-semibold"
      >
        Return to cart
      </button>
    </div>
  );
}
